import { Injectable } from '@angular/core';

import * as fileSaver from 'file-saver';
import { ConfigServerService, CustomHttp } from '../../../../../core';
import { CurvaAbcVendaFilter, CurvaAbcVendaFilterService } from '../../filter';
import { CurvaAbcVendaPerspectiva } from '../../perspectiva';

@Injectable({
    providedIn: 'root'
})
export class CurvaAbcVendaExcelHttpService {
    private readonly resource = 'curvaabcvenda';
    private readonly path: string;


    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp,
                private curvaAbcVendaFilterService: CurvaAbcVendaFilterService) {
        this.path = `${configServerService.getPathApiExcel()}/${this.resource}`;
    }

    /** Realiza a exportação da Curva ABC de Vendas para Excel */
    export(perspectiva: CurvaAbcVendaPerspectiva, filter: CurvaAbcVendaFilter, orderBy: number, orderByDir: string, nomeExportacao = ''): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            let params = this.curvaAbcVendaFilterService.createHttpParams(perspectiva, filter, orderBy, orderByDir);
            params = params.append('nomeExportacao', nomeExportacao);

             this.customHttp.get<Blob>(`${this.path}/export`, {params, responseType: 'blob'})
                .subscribe(
                    excel => {
                        nomeExportacao = nomeExportacao.replace('.xlsx', '');
                        fileSaver.saveAs(excel, `${nomeExportacao}.xlsx`);
                        resolve();
                    },
                    error => {
                        reject(error);
                    }
                );
        });
    }
}
